import {TEntryType} from "../../../index";

export namespace nsHistory {

    export const getRegExpComment_rule = () => /^.*? by rule (.*?) id: (\d*?)$/gm;
    export const getRegExpComment_user = () => /^.*? by user (.*?) id: (\d*?)$/gm;

}
